import { create } from 'zustand'
import type { DeviceStatus, PlayerScreen } from '@/types/player.types'

interface PlayerState {
  screen: PlayerScreen
  deviceStatus: DeviceStatus | null
  errorMessage: string | null
  isOffline: boolean

  setScreen: (screen: PlayerScreen) => void
  setDeviceStatus: (status: DeviceStatus) => void
  setError: (message: string) => void
  setOffline: (offline: boolean) => void
}

export const usePlayerStore = create<PlayerState>()((set) => ({
  screen: 'initializing',
  deviceStatus: null,
  errorMessage: null,
  isOffline: false,

  setScreen: (screen) => set({ screen }),
  setDeviceStatus: (deviceStatus) => set({ deviceStatus }),
  setError: (errorMessage) => set({ errorMessage, screen: 'error' }),
  setOffline: (isOffline) => set({ isOffline })
}))
